import {FC, useCallback} from "react";
import Delete from "@mui/icons-material/Delete";
import IconButton, {IconButtonProps} from "@mui/material/IconButton";
import {useFeedback} from "@memaro/feedback";

type DeleteButtonProps = Omit<IconButtonProps, "color" | "size"> & {
    onClick: () => void
}

const DeleteButton: FC<DeleteButtonProps> = ({onClick, ...rest}) => {
    const {confirm} = useFeedback()

    const handleClick = useCallback(async () => {
        if (await confirm?.("Weet u zeker dat u deze sectie wil verwijderen?")) {
            onClick()
        }
    }, [confirm, onClick]);

    return (
        <IconButton onClick={handleClick} color="error" size="small" {...rest} >
            <Delete/>
        </IconButton>
    )
}


export default DeleteButton
